import { Injectable, inject } from '@angular/core';
import { SiaPermissionsApi } from '../apis/sia-permissions.api';
import { SiaPermissionsConfig } from '../interfaces/sia-permissions-config';
import { SiaUserPermissions } from '../interfaces/sia-user-permissions';

@Injectable({
  providedIn: 'root',
})
export class SiaPermissionsService {
  private api = inject(SiaPermissionsApi);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  applyRule(ruleParams: { componentTypeId: string[]; groupId: string[]; action: string; cloneGroupId: string }) {
    return this.api.applyRule(ruleParams);
  }

  getPermissions(userId: number, componentId: string): Promise<SiaUserPermissions> {
    return this.api.getPermissions(userId, componentId);
  }

  createEmptyPermissions() {
    return this.api.createEmptyPermissions();
  }

  getPermissionsConfig(): Promise<SiaPermissionsConfig[]> {
    return this.api.getPermissionsConfig();
  }

  updateRows(rows: SiaPermissionsConfig[]): Promise<boolean> {
    return this.api.updateRows(rows);
  }
}
